<template>
    <v-container fluid pa-0 ma-0>
        <v-row justify="end" align="center" no-gutters>
            <v-col cols="auto" class="pl-5 pr-3">
                <div style="height: 70px; border: 1px solid rgba(255,255,255,0.6);"></div>
            </v-col>
            <v-col cols="auto">
                <v-card flat
                        color="rgba(0,0,0,0)"
                        @click="openSettings()"
                        v-ripple
                ><v-card-text class="py-2 px-5">
                        <v-row justify="center" align="center">
                            <v-icon  class="mr-1">mdi-settings</v-icon>
                            <span class="body-1">{{$t('general.settings')}}</span>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        name: "Settings",
        methods: {
            openSettings() {
                this.$store.dispatch('settings/toggleSettingsDrawer', !this.$store.state.settings.isOpen);
            }
        }
    }
</script>

<style scoped>

</style>